/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import styled from 'styled-components'
import { ReactComponent as Arrow } from '../../assets/icons/black-arrow.svg'

const Wrapper = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #d4d4d4;
    padding: 8px 16px;
    border-radius: 16px;
    cursor: pointer;
    .title {
      color: #343a4f;
      font-size: 14px;
      line-height: 20px;
      font-family: "CircularStd-Book";
      flex: 9;
    }
    svg {
      flex: 1;
      ${( { isOpen } ) => isOpen && 'transform: rotate(-180deg);'}
      transition: transform 0.2s;
    }
    svg path {
      stroke: #21c5e5;
    }
  }
  .div-description {
    padding: 5px 5px 5px 10px;
  }
  .description {
    color: #676c84;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.025em;
    font-family: "Noto Sans", sans-serif;
  }
`

const WrapperComponent = ( { opcional } ) => {
  const [ isOpen, setIsOpen ] = useState( false )

  function handleClickArrow() {
    setIsOpen( !isOpen )
  }

  return (
    <Wrapper isOpen={ isOpen }>
      <div
        className="header"
        onClick={ handleClickArrow }
      >
        <span className="title"> {opcional.titulo}</span>

        <Arrow />
      </div>

      { isOpen ?
        <div className="div-description">
          <span className="description"> {opcional.texto}</span>
        </div> : null }
    </Wrapper>
  )
}

export default WrapperComponent
